import { Box, Flex, HStack, SimpleGrid, Stack, Text } from '@chakra-ui/react';
import { Star } from '@time-line/components/icons';
import { clamp } from '@time-line/components/utils';

import {
  MULTI_PRODUCT_RECOMMEND_LABEL,
  SINGLE_PRODUCT_RECOMMEND_LABEL,
} from '../constants';

interface ProductReviewStatsProps {
  totalReviews: number;
  recommendedPercentage?: number;
  averageScore: number;
  isMultiProduct?: boolean;
}

export function ProductReviewStats({
  totalReviews,
  recommendedPercentage,
  averageScore,
  isMultiProduct,
}: ProductReviewStatsProps) {
  const averageScoreFloat = parseFloat(averageScore.toFixed(1));
  const totalReviewsString = `Based on ${totalReviews} reviews`;

  return (
    <SimpleGrid columns={recommendedPercentage ? 2 : 1} gap="2xs">
      <Stack gap="4xs">
        <Flex alignItems="flex-end">
          <Box height={clamp(30, 45)} mr="5xs" mb="-6px">
            <Text lineHeight="none">
              <Text as="span" size="h2" mr="4xs" lineHeight="none">
                {averageScoreFloat}
              </Text>
              <Text as="span" size="body2" lineHeight="none">
                / 5
              </Text>
            </Text>
          </Box>
          <Star />
        </Flex>
        {totalReviews > 0 && (
          <Text size="title-serif">{totalReviewsString}</Text>
        )}
      </Stack>
      {recommendedPercentage && (
        <Stack gap="4xs">
          <HStack height={clamp(30, 45)} alignItems="end" mb="-6px">
            <Text lineHeight="none">
              <Text as="span" size="h2" mr="5xs">
                {Math.round(recommendedPercentage)}
              </Text>
              <Text as="span" size="body2">
                %
              </Text>
            </Text>
          </HStack>
          <Text size="title-serif">
            {isMultiProduct
              ? MULTI_PRODUCT_RECOMMEND_LABEL
              : SINGLE_PRODUCT_RECOMMEND_LABEL}
          </Text>
        </Stack>
      )}
    </SimpleGrid>
  );
}
